/* Knops performance-laag (v1)
   - Detecteert "TV-modus" (zeer grote viewport, bijv. 75" op 4K met een mini-pc)
     en zet html.kp-tv, zodat CSS zware effecten kan uitzetten.
   - Pauzeert autoplay-video's buiten beeld (GPU/CPU-last omlaag).
   - Zet video's buiten beeld op preload=metadata; laadt foto's vooruit
     (3 schermhoogtes) zodat snel scrollen geen lege vlakken geeft.
   Geen enkele wijziging aan lay-out of inhoud. */
(function () {
  'use strict';
  var de = document.documentElement;
  var isTV = Math.max(window.innerWidth || 0, (window.screen && screen.width) || 0) >= 2400;
  if (isTV) { de.classList.add('kp-tv'); }

  /* Trage verbinding (hotel/vakantie-wifi, 3G, databesparing): minder en kleinere foto's laden. */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
  var slow = !!(conn.saveData || /(^|-)(slow-2g|2g|3g)$/.test(conn.effectiveType || '') || (conn.downlink && conn.downlink < 3.5) || (conn.rtt && conn.rtt > 450));
  if (slow) { de.classList.add('kp-slow'); }

  function vh() { return window.innerHeight || 800; }
  function nearViewport(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > -200 && r.top < vh() * 1.2;
  }

  /* Foto's: NIET uitstellen, maar juist vooruit laden. Lazy-foto's binnen ~3
     schermhoogtes onder/boven het beeld worden alvast opgehaald, en daarna
     laadt de rest in kleine porties zodra de browser rustig is. Zo staan ze
     er al als je snel scrolt. */
  function tuneImages() {
    var imgs = document.querySelectorAll('img');
    var lazy = [];
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (!im.hasAttribute('decoding')) { im.decoding = 'async'; }
      if (im.loading === 'lazy' && !im.complete) { lazy.push(im); }
    }
    if (!lazy.length) { return; }
    var go = function (im) {
      if (im.loading !== 'lazy') { return; }
      if (slow) { /* kleinere variant ophalen op trage verbinding */
        var u = im.getAttribute('src') || '';
        var m = /([?&]width=)(\d+)/.exec(u);
        if (m && parseInt(m[2], 10) > 1280) { im.removeAttribute('srcset'); im.setAttribute('src', u.replace(m[0], m[1] + '1280')); }
      }
      im.loading = 'eager';
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { go(e.target); io.unobserve(e.target); } });
      }, { rootMargin: slow ? '60% 0px 60% 0px' : '300% 0px 300% 0px' });
      lazy.forEach(function (im) { io.observe(im); });
    }
    /* Rest in porties van 3, in documentvolgorde, wanneer het rustig is. */
    /* Niet de hele pagina vooraf binnenhalen: maximaal 18 extra foto's, en op trage verbinding helemaal niet. */
    var queue = slow ? [] : lazy.slice(0, 18), idle = window.requestIdleCallback || function (f) { return setTimeout(f, 300); };
    function pump() {
      var n = 3;
      while (n-- && queue.length) { go(queue.shift()); }
      if (queue.length) { setTimeout(function () { idle(pump); }, 350); }
    }
    window.addEventListener('load', function () { setTimeout(function () { idle(pump); }, 1500); });
  }

  function tuneVideos() {
    var vids = document.querySelectorAll('video');
    if (!vids.length) { return; }
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (!nearViewport(v) && v.preload !== 'none') { v.preload = slow ? 'none' : 'metadata'; }
    }
    if (!('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (!v.hasAttribute('autoplay')) { return; } /* hover/klik-video's met rust laten */
        if (e.isIntersecting) {
          if (v.dataset.kpPaused === '1') {
            v.dataset.kpPaused = '';
            var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
          }
        } else if (!v.paused) {
          v.dataset.kpPaused = '1';
          v.pause();
        }
      });
    }, { rootMargin: '400px 0px', threshold: 0.01 });
    for (var j = 0; j < vids.length; j++) { io.observe(vids[j]); }
  }

  function run() { tuneImages(); tuneVideos(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
  window.addEventListener('load', function () { setTimeout(run, 600); });
})();
